export function CollapseIcon() {
  return (
    <svg width='15' height='9' viewBox='0 0 15 9' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M1.5 1.4375L7.5 7.0625L13.5 1.4375' stroke='#F2C94C' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
}
